import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Button';
import { Dialog } from 'src/components/Dialog';
import { Stack } from 'src/components/Stack';
import { TextField } from 'src/components/TextField';

interface PosAddEditTemplateDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
  posName?: string;
}

export default function PosAddEditTemplateDialog({
  open,
  onClose,
  onSave,
  posName = '',
}: PosAddEditTemplateDialogProps) {
  const [name, setName] = useState(posName);
  const { t } = useTranslation('translation', {
    keyPrefix: 'posPreview',
  });

  const handleSave = () => {
    onSave(name);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      title={posName ? t('editTemplate') : t('addTemplate')}
      subtitle={posName ? t('editTemplateSubtitle') : t('addTemplateSubtitle')}
    >
      <Stack spacing={2}>
        <TextField
          label={t('templateName')}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="text" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button variant="contained" onClick={handleSave} disabled={!name}>
            {posName ? t('saveTemplate') : t('createTemplate')}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
